export const NEW_TASK_SEARCH_PARAM = 'new-task';
